import React from "react";
import { LegalLayout, LegalSection } from "@/components/LegalLayout";

const SECTIONS = [
  { id: "agreement", title: "Agreement" },
  { id: "service", title: "The Service" },
  { id: "not-advice", title: "Not Professional Advice" },
  { id: "accounts", title: "Accounts" },
  { id: "subscriptions", title: "Subscriptions & Payments" },
  { id: "acceptable-use", title: "Acceptable Use" },
  { id: "ai-content", title: "AI-Generated Content" },
  { id: "termination", title: "Termination" },
  { id: "disclaimers", title: "Disclaimers & Liability" },
  { id: "contact", title: "Contact" },
];

export default function Terms() {
  return (
    <LegalLayout
      metaTitle="DECIDE — Terms of Service"
      metaDescription="Terms of Service for DECIDE, the decision-making application."
      title="Terms of Service"
      subtitle="The terms that govern your use of DECIDE."
      updated="13 June 2026"
      toc={SECTIONS}
    >
      <div className="mb-8 rounded-2xl border border-decide-warn/40 bg-decide-warnSoft p-4 text-[14px] leading-relaxed text-decide-ink">
        This Terms of Service is provided as a starting point by DGG Labs and should be reviewed and completed
        (with legal counsel) before publication.
      </div>

      <LegalSection id="agreement" index={1} title="Agreement">
        <p>By accessing or using DECIDE, you agree to these Terms of Service. If you do not agree, please do not use the service. DECIDE is operated by DGG Labs.</p>
      </LegalSection>
      <LegalSection id="service" index={2} title="The Service">
        <p>DECIDE helps you structure and analyse personal and practical decisions and produces an AI-generated analysis and recommendation. Features and availability may change over time.</p>
      </LegalSection>
      <LegalSection id="not-advice" index={3} title="Not Professional Advice">
        <p>DECIDE structures your thinking and is not a substitute for professional advice. For medical, legal, financial, or other high-stakes matters, consult a qualified professional. You are solely responsible for your decisions.</p>
      </LegalSection>
      <LegalSection id="accounts" index={4} title="Accounts">
        <p>Some features require signing in with Google. You are responsible for activity under your account. You may delete your account at any time in Settings or at <a className="text-decide-forest underline underline-offset-2" href="/delete-account">/delete-account</a>.</p>
      </LegalSection>
      <LegalSection id="subscriptions" index={5} title="Subscriptions & Payments">
        <p>DECIDE offers a free tier and a paid subscription (DECIDE Pro), billed monthly or yearly through Stripe. Subscriptions renew until cancelled. Pricing and terms are shown at checkout.</p>
      </LegalSection>
      <LegalSection id="acceptable-use" index={6} title="Acceptable Use">
        <p>You agree not to misuse DECIDE, including attempting to disrupt the service, reverse-engineer it, or use it for unlawful purposes.</p>
      </LegalSection>
      <LegalSection id="ai-content" index={7} title="AI-Generated Content">
        <p>Analyses are generated by an AI model and may contain errors or omissions. Use your own judgement. You can report problematic responses from within the analysis view.</p>
      </LegalSection>
      <LegalSection id="termination" index={8} title="Termination">
        <p>We may suspend or terminate access for violations of these terms or to protect the service. You may stop using DECIDE and delete your account at any time.</p>
      </LegalSection>
      <LegalSection id="disclaimers" index={9} title="Disclaimers & Liability">
        <p>DECIDE is provided “as is” without warranties of any kind. To the maximum extent permitted by law, DGG Labs is not liable for any indirect or consequential damages arising from your use of the service.</p>
      </LegalSection>
      <LegalSection id="contact" index={10} title="Contact">
        <p>Questions about these terms: <a className="text-decide-forest underline underline-offset-2" href="mailto:dgg.operations@gmail.com">dgg.operations@gmail.com</a>.</p>
      </LegalSection>
    </LegalLayout>
  );
}
